// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 2:15 AM
 */
import {connect} from "react-redux";
import type {HeaderBarDispatchProps, HeaderBarStateProps} from "../../components/HeaderBar";
import HeaderBar from "../../components/HeaderBar";
import type {MenuCloseAction, MenuOpenAction} from "../../actions/menu/menuAction";
import type {StoreState} from "../../reducers/combinedReducers";
import * as _ from 'lodash';
import type {LogoutAction} from "../../actions/profile/logoutAction";
import {removeJwt, removeProfile} from "../../dao/localStorageProfileDao";
import type {RoleConfig} from "../../types/utilityTypes";
import {computeUserConfigs} from "../../helpers/utils";

const mapStateToProps = (state: StoreState): HeaderBarStateProps => {

    let roleConfig: RoleConfig = computeUserConfigs(state.loginUser.roleIds);

    return {
        open: state.menu.open,
        name: _.get(state, "profile.name"),
        roleConfig
    };
};

const mapDispatchToProps = (dispatch: (action: MenuOpenAction | MenuCloseAction | LogoutAction) => any): HeaderBarDispatchProps => {
    return {
        openMenu: () => {
            dispatch({
                type: "menu/MENU_OPEN_ACTION"
            });
        },
        closeMenu: () => {
            dispatch({
                type: "menu/MENU_CLOSE_ACTION"
            });
        },
        logout: async () => {
            removeProfile();
            await removeJwt();
            dispatch({
                type: "profile/LOGOUT_ACTION"
            });
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar);



// WEBPACK FOOTER //
// ./src/containers/header/HeaderBar.js